import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChangeLog, Pagination, Response } from '@ui/src';
import { AccountActivityLog, Balance } from '../../../../customers/types';
import { AccountLogs, UserAccountProps } from '../../../types';
import { individualCustomersApi } from '../../services/individual';
import { customersComponentApi } from '../../../../customers/store/services/customers';

export interface IndividualCustomerAccountsState {
  accountsActivityLog: {
    isLoading: boolean;
    values?: AccountActivityLog[];
  };
  logs?: AccountLogs[];
  accountsLogs?: ChangeLog[];
  accountsLogsPagination?: Pagination;
  closedBalances?: {
    id: string;
    value: number;
    currencyId: string;
  }[];
}

const initialState: IndividualCustomerAccountsState = {
  accountsActivityLog: {
    isLoading: false,
  },
};

export const individualCustomerAccountsSlice = createSlice({
  name: 'individualCustomerAccounts',
  initialState,
  reducers: {
    clearAccountsState: (state) => {
      state.accountsActivityLog.values = undefined;
    },
    clearSettingsPanel: (state) => {
      state.logs = undefined;
      state.accountsLogs = undefined;
      state.accountsLogsPagination = undefined;
      state.closedBalances = undefined;
    },
    clearClosingBalances: (state) => {
      state.closedBalances = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualCustomersApi.endpoints.getIndividaulAccountLogs.matchFulfilled,
      (state, action: PayloadAction<{ data: UserAccountProps }>) => {
        state.logs = action.payload.data.statusLogs;
      },
    );
    builder.addMatcher(
      individualCustomersApi.endpoints.getIndividualAccountClosingBalances
        .matchFulfilled,
      (state, action: PayloadAction<{ data: Balance[] }>) => {
        state.closedBalances = action.payload.data;
      },
    );
    builder.addMatcher(
      customersComponentApi.endpoints.getCustomersAccountsChangeLogs
        .matchFulfilled,
      (
        state,
        action: PayloadAction<Response<ChangeLog>> & {
          meta: { arg: { originalArgs: string } };
        },
      ) => {
        if (!action.meta.arg.originalArgs.includes('cursor')) {
          state.accountsLogs = action.payload.data?.edges?.map(
            (item) => item.node,
          );
        } else {
          const nextChangeLogs = ([] as ChangeLog[]).concat(
            state.accountsLogs as ChangeLog[],
          );

          action.payload.data.edges?.forEach((item) => {
            nextChangeLogs.push(item.node);
          });

          state.accountsLogs = nextChangeLogs;
        }

        state.accountsLogsPagination = action.payload.data?.pageInfo;
      },
    );
  },
});

export const { clearAccountsState, clearSettingsPanel, clearClosingBalances } =
  individualCustomerAccountsSlice.actions;

export default individualCustomerAccountsSlice.reducer;
